var React = require('react');

function Cancel (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M12 3.667c-4.608 0-8.333 3.725-8.333 8.333 0 4.608 3.725 8.333 8.333 8.333 4.608 0 8.333-3.725 8.333-8.333 0-4.608-3.725-8.333-8.333-8.333zm3.583 11.916c-.155.156-.367.244-.587.244-.22 0-.432-.088-.588-.244L12 13.175l-2.408 2.408c-.21.21-.516.292-.803.215-.287-.076-.51-.3-.587-.587-.077-.287.005-.593.215-.803L10.825 12 8.417 9.592c-.325-.325-.325-.85 0-1.175.324-.325.85-.325 1.175 0L12 10.825l2.408-2.408c.21-.21.516-.292.803-.215.287.076.51.3.587.587.077.287-.005.593-.215.803L13.175 12l2.408 2.408c.317.317.317.85 0 1.175z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})]));
}

Cancel.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Cancel;

Cancel.default = Cancel;
